class AccordionGroup extends HTMLElement {
  constructor() {
    super()

    this.openEvent = 'accordion:open'
    this.accordionSelector = 'domaine-accordion'
  }

  connectedCallback() {
    this.addEventListener(this.openEvent, this.onAccordionOpen.bind(this))
  }

  disconnectedCallback() {
    this.removeEventListener(this.openEvent, this.onAccordionOpen)
  }

  onAccordionOpen(e) {
    this.accordions = [...this.querySelectorAll(this.accordionSelector)]
    if (!this.accordions.length) return

    this.accordions.map((accordion) =>
      accordion.toggleAttribute('will-close', e.target !== accordion)
    )
  }
}

customElements.define('domaine-accordion-group', AccordionGroup)

class Accordion extends HTMLElement {
  constructor() {
    super()
    this.details = this.querySelector('details')
    this.summary = this.querySelector('summary')
    this.content = this.summary.nextElementSibling
  }

  connectedCallback() {
    this.summary.addEventListener('click', this.handleClick.bind(this))
  }

  disconnectedCallback() {
    this.summary.removeEventListener('click', this.handleClick)
  }

  // watch for closing attribute
  static get observedAttributes() {
    return ['will-close']
  }

  attributeChangedCallback(name, _, newValue) {
    if (name === 'will-close' && newValue !== null) {
      this.toggle(false)
    }
  }

  async handleClick(e) {
    e.preventDefault()
    this.toggle(!this.details.open)
  }

  async toggle(open) {
    this.dispatchEvent(
      new CustomEvent(`accordion:${open ? 'open' : 'close'}`, { bubbles: true })
    )
    this.details.style.overflow = 'hidden'
    if (open) {
      this.details.open = open
      this.details.classList.add('opening')
    } else {
      this.details.classList.add('closing')
      this.details.classList.remove('open')
    }

    this.details.open = open
    this.details.style.height = ''
    this.details.style.overflow = ''
    this.details.classList.remove('opening', 'closing', 'open')
    this.details.classList.toggle('open', open)
  }
}

customElements.define('domaine-accordion', Accordion)
